import React, { Component } from 'react';
import * as Config from './../../config/Config';
import * as Common from './../../helpers/Common';
import * as User from './../../helpers/User';
const $=window.$;

//const $=window.$;
// const win=window;

class AssessementStatus extends Component {
	constructor(props) {
		super(props);

        this.state={
				ass_status : [],        	
				};

		this.getSentMail = this.getSentMail.bind(this);

	}

	componentWillReceiveProps(nextProps) {

    }

    getList(){
    	let learnerID   = Common.getUserData("id", true);
    	// let learnerID = '96715';
			let pinNo 		= Common.getUserData("pinNo", true);
			let pinID 		= Common.getUserData("pinID", true);
			let corporateID = Common.getUserData("corporateID", true);
			let productID 	= Common.getUserData("productID", true);
			Common.reactLoader("show", "Please wait...");
    	fetch(Config.domainUrl+'learning/performance-assess', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
				  'Authorization':'Bearer ' +Common.getTokenData()
                },
                  body: JSON.stringify({
                    learnerID:learnerID,
					pinNo:pinNo,
					pinID:pinID,
					corporateID:corporateID,
					productID:productID
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
               		Common.reactLoader("hide");
               		if(responseJson.status != 0){
						this.setState({
							ass_status : responseJson.performance_asses
						})
					}				 
   				});
        Common.downTabClose();
    }

    getSentMail(mail,evals,component){
    	this.props.sentData(mail,evals,component);
    }


	componentDidMount() {
		this.getList();
	}

	render() {
		let ass_status = [];
      	if(this.state.ass_status!=null || this.state.ass_status!=undefined) {
			ass_status = this.state.ass_status.map((ass,l)=>{
				return(
						<tr key={`ass_${l}`} bgcolor="#ffffff">
							<td>{ass.no}</td>
							<td>{ass.lr_no}</td>
							<td>{ass.component}</td>
							<td>{ass.evaluator_id}</td>
							<td>{ass.sentdate}</td>
							<td>{(ass.assesseddate==""||ass.assesseddate==null)?<a href="javascript:void(0);" onClick={()=>this.getSentMail(ass.mail_id,ass.evaluator_id,ass.component)}>YTA</a>:<span>{ass.assesseddate}</span>}</td>
							<td>{(ass.score==0)?<a href="javascript:void(0);" onClick={()=>this.getSentMail(ass.mail_id,ass.evaluator_id,ass.component)}>YTA</a>:<span>{ass.score}</span>}</td>
						</tr>
					)
			})
		}

		return (
			 
						<div >
							<table cellPadding="0" cellSpacing="0" width="100%" id="view" className="myjourney-table border-blue" border="0">
							    <thead>
							        <tr>
							            <th>S.No </th>
							            <th>LR No <img src={process.env.PUBLIC_URL+"/images/sort-arrow.png"} border="0"/></th>
							            <th>Component Name</th>
							            <th>Observer Name<img src={process.env.PUBLIC_URL+"/images/sort-arrow.png"} border="0"/></th>
							            <th>Sent date<img src={process.env.PUBLIC_URL+"/images/sort-arrow.png"} border="0"/></th>
							            <th>Assessed date<img src={process.env.PUBLIC_URL+"/images/sort-arrow.png"} border="0"/></th>
							            <th>Assessed Score<img src={process.env.PUBLIC_URL+"/images/sort-arrow.png"} border="0"/></th>
							        </tr>
							    </thead>
							    <tbody>
							    	{(!ass_status.length)?<tr><td  colSpan='7'>No Recods Found</td></tr>:ass_status}
							    </tbody> 
							</table>
						</div>
						
			);

	}
}

export default AssessementStatus;



// WEBPACK FOOTER //
// ./src/learning_records/my_performance/AssessementStatus.js